import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { WebPortalClient, QueryOfSvcAnalysisSet, QueryOfSvcSession } from "webportalclient";
import { ODataParams, Query } from "../../Components/Query";
import SvcAnalysisSetListTable from "./AnalysisSetsList/SvcAnalysisSetListTable";
import SvcSessionsListTable from "./SvcSessionsList/SvcSessionsListTable";
import { SvcAnalysisScreen } from "./SvcAnalysisScreen";
import { useSecurityContext } from "../../Core/SecurityContext";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { OverreadStatusIdEnum } from "../../misc/api/apiTypes";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const SvcRoot = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const refreshSvcSessions = async (params: ODataParams): Promise<QueryOfSvcSession> => {
        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `visit/subject/site/studyId eq ${study.id}`;

        const constraints = 'analysisSets($select=type,status,analystUserName,id),tests($select=index),visit($expand=subject($expand=site($select=number,studyId)))';

        return await client.client.getSvcSessions(undefined, filter, params.orderby, constraints, params.top, params.skip, undefined, true);
    }

    const refreshSvcAnalysisSets = async (params: ODataParams): Promise<QueryOfSvcAnalysisSet> => {
        let filter = params.filter ? `(${params.filter}) and ` : '';

        filter += `session/visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getSvcAnalysisSets(undefined, filter, params.orderby, 'session($expand=visit($expand=subject($expand=site($select=number,studyId))))', params.top, params.skip, undefined, true);
    }

    return (
        <Switch>
            <Route path="/Svc" exact>
                <Query onRefresh={refreshSvcSessions} initialOrdering={[{ field: "occurred", condition: "desc" }]}>
                    <SvcSessionsListTable />
                </Query>
            </Route>
            <Route path="/Svc/Analysis" exact>
                <Query onRefresh={refreshSvcAnalysisSets}
                    initialFilters={[
                        { field: "status", condition: "eq", values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted] },
                    ]}
                    initialOrdering={[{ field: "created", condition: "asc" }]}
                >
                    <SvcAnalysisSetListTable />
                </Query>
            </Route>
            <Route path="/Svc/Analysis/:analysisSetId/:viewState" component={SvcAnalysisScreen} />
        </Switch>
    );
}
